import type { CanonicalQuickRangeKey } from "@/components/date-range/quickRange";

export enum TrainingType {
	All = "All",
	Courses = "Courses",
	Exercises = "Exercises",
	Events = "Events",
}

export interface ArchiveDashboardProps {
	initialTrainingType?: TrainingType;
	name?: React.ReactNode;
}

export interface ArchivedSessionsDataGridProps {
	startDate?: Date;
	endDate?: Date;
	trainingType: TrainingType;
}

export interface SessionsAccordionProps {
	items: import("@/service/TrainingQueries").UserItem[];
	isLoading?: boolean;
}

export interface UpcomingSessionsProps {
	type: "drill" | "course";
	data: "overdue" | "upcoming";
	name?: React.ReactNode;
}

export type KPIField = "Average" | "Count";

export interface KpiStatistic {
	Date: string;
	Name: string;
	Average: number;
	Count: number;
}

export interface KpiStatisticsDataGridProps {
	startDate?: Date;
	endDate?: Date;
	selectedRange?: CanonicalQuickRangeKey;
	onRangeChange?: (range: CanonicalQuickRangeKey) => void;
}

export interface DashboardCardConfig {
	type: "course" | "drill" | "archive";
	data?: "upcoming" | "overdue";
	trainingType?: TrainingType;
	name: React.ReactNode;
}

export interface DashboardCardGroupConfig {
	key: string;
	title: React.ReactNode;
	description: React.ReactNode;
	cards: DashboardCardConfig[];
}
